module.exports = __webpack_public_path__ + "img/apolar-procura-section-image.6c1d922e.webp";